import { render, staticRenderFns } from "./LeumiIphoneChromeAlert.vue?vue&type=template&id=30f2ebf4&scoped=true"
import script from "./LeumiIphoneChromeAlert.vue?vue&type=script&lang=js"
export * from "./LeumiIphoneChromeAlert.vue?vue&type=script&lang=js"
import style0 from "./LeumiIphoneChromeAlert.vue?vue&type=style&index=0&id=30f2ebf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f2ebf4",
  null
  
)

export default component.exports